
import { Base } from '../../components/base-component';

import './form-item-access-quote-pc.component.scss';

export class FormItemAccessQuotePc extends Base {

	form: HTMLFormElement;
	submitBtn: Element[];

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = Array.from(this.element.querySelectorAll('.js-apply-now-pc__button'));

	}

	bindEvents() {

		this.submitBtn.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.formsService.detect(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));

	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-access-quote-pc/form-item-access-quote-pc.component.ts